<section>
  <div class="flex justify-between items-end">
    <div>
      <h1>Staff Details</h1>
    </div>
    <div class="flex items-center gap-3">
      <div class="dropdown dropdown-bottom dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm btn-primary border flex items-center">
          Actions <i class="ri-arrow-down-s-line"></i>
        </div>
        <ul tabindex="0"
          class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
          <li><a>Manage Permissions</a></li>
          <li><a class="text-red-500">Delete Staff</a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-5">
    <div class="lg:col-span-1 staff-profile-scroll">
      @if (isFetching) {
      <div class="flex justify-center py-10">
        <app-loader></app-loader>
      </div>
      } @else if (staffData) {
      <app-staff-student-common-profile-view [profileData]="staffData"></app-staff-student-common-profile-view>
      } @else {
      <div class="p-5 bg-white rounded-lg border text-center text-sm text-zinc-500">
        No staff details found.
      </div>
      }
    </div>

    <div class="lg:col-span-2">
      <div class="staff-tabs">
        <button class="staff-tab active">Activity Log</button>
      </div>

      <div class="staff-card mt-4">
        <div class="staff-card__header">
          <h3>Log</h3>
        </div>
        <div class="staff-card__body">
          <div class="timeline">
            @for (i of activityLog; track $index) {
            <div class="timeline-row">
              <div class="timeline-time">
                <span>{{i.date}}</span>
                <span>{{i.time}}</span>
              </div>
              <div class="timeline-line">
                <span class="dot"></span>
                <span class="line"></span>
              </div>
              <div class="timeline-text">{{i.text}}</div>
              <div class="timeline-status" [ngClass]="{'ok': i.status === 'success', 'bad': i.status === 'error'}">
                <i class="ri-check-line" *ngIf="i.status === 'success'"></i>
                <i class="ri-close-line" *ngIf="i.status === 'error'"></i>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
